/**
 * @file ローディングアイコン。通信中のAPI数が1つ以上あればローディング表示。
 *        body scrollを無効化してユーザー操作を防ぎ、全API完了時にscroll制御を解除。
 */
import React from 'react';
import { useRecoilValue } from 'recoil';
import url from '@/utils/config';
import loadingStatus from '@/states/loadingState';

const LoadingIcon: React.FC = () => {
  const isLoading = useRecoilValue(loadingStatus);

  // loadingStateは通信中APIのURL配列。配列が空でない限りローディングを表示
  if (isLoading.length !== 0) {
    // ローディング中はbodyスクロールを無効化してユーザーの誤操作を防止
    if (typeof window === 'object') {
      document.body.style.overflow = 'hidden';
    }
    return (
      <div className='loading_icon' data-testid='loading'>
        <img src={url('/images/icon_loader.gif')} alt='ローディング中' />
      </div>
    );
  }
  // 全API完了時: スクロール制御を解除して通常操作に復帰
  if (typeof window === 'object') {
    document.body.style.overflow = '';
  }
  return <div data-testid='hidden_loading' />;
};

export default LoadingIcon;
